
import { Vue } from "vue-class-component";

export default class IncomingCurrentStt extends Vue {}
